module.exports = __webpack_public_path__ + "9925b07a03e0644658b79d202f670f98.svg";